import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'pre-auth',
    loadChildren: () =>
      import('./module/pre-auth/pre-auth.module').then((m) => m.PreAuthModule),
  },
  {
    path: 'post-auth',
    loadChildren: () =>
      import('./module/post-auth/post-auth.module').then(
        (m) => m.PostAuthModule,
      ),
  },
  {
    path: 'bcci',
    loadChildren: () =>
      import('./module/bcci/bcci.module').then((m) => m.BcciModule),
  },
  { path: '404', component: PageNotFoundComponent },
  { path: '', redirectTo: 'pre-auth', pathMatch: 'full' },
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
